import Head from 'next/head';
import Typography from '@material-ui/core/Typography';
import MLink from '@material-ui/core/Link';
import { buildTitle } from '../utils/layout';
import config from '../config';
import Main from '../components/main';

const Contact = () => {
  return (
    <Main>
      <Head>
        <title>{buildTitle('Contact')}</title>
        <link rel="canonical" href={`${config().universal.baseUri}/contact`} />
      </Head>
      <Typography variant="h1">Contact</Typography>
      <p>
        Please
        {' '}
        <MLink href="mailto:support@everydayrides.com">reach out via email</MLink>
        {' '}
        if you have any questions, feedback, or want to get in touch.
      </p>
    </Main>
  );
};

export default Contact;
